import { render, staticRenderFns } from "./CNIProjectStatus.vue?vue&type=template&id=1f58bed2&"
import script from "./CNIProjectStatus.vue?vue&type=script&lang=js&"
export * from "./CNIProjectStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports